import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft, Mail, Search } from "lucide-react";
import logoIcon from "@/assets/logo-icon.webp";
import SEO from "@/components/SEO";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  const popularPages = [
    { name: "Healthcare", path: "/industries/healthcare" },
    { name: "Restaurants", path: "/industries/restaurants" },
    { name: "Real Estate", path: "/industries/real-estate" },
    { name: "Education", path: "/industries/education" },
  ];

  return (
    <>
      <SEO 
        title="Page Not Found | Review Plum"
        description="The page you're looking for doesn't exist. Return to Review Plum homepage to explore our AI-powered Google review generation platform."
        noIndex={true}
      />
      <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
        <div className="text-center max-w-lg">
          {/* Logo */}
          <div className="flex items-center justify-center gap-2 mb-8">
            <img src={logoIcon} alt="Review Plum" className="w-10 h-10" loading="lazy" />
            <span className="text-xl font-semibold text-foreground">Review Plum</span>
          </div>

          {/* 404 Error */}
          <div className="mb-6">
            <h1 className="text-8xl font-bold text-primary mb-2">404</h1>
            <h2 className="text-2xl font-semibold text-foreground mb-2">Page Not Found</h2>
            <p className="text-muted-foreground">
              Oops! The page you're looking for doesn't exist or may have been moved.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-8">
            <Button 
              onClick={() => navigate('/')}
              className="gradient-btn"
            >
              <Home className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
            <Button 
              variant="outline"
              onClick={() => navigate(-1)}
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Go Back
            </Button>
          </div>

          {/* Popular Pages */}
          <div className="border-t border-border pt-6">
            <p className="text-sm text-muted-foreground mb-4 flex items-center justify-center gap-2">
              <Search className="w-4 h-4" />
              Looking for something? Try these popular pages:
            </p>
            <div className="flex flex-wrap justify-center gap-2">
              {popularPages.map((page) => (
                <Button
                  key={page.path}
                  variant="ghost"
                  size="sm"
                  onClick={() => navigate(page.path)}
                  className="text-primary hover:text-primary/80"
                >
                  {page.name}
                </Button>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div className="mt-8 text-sm text-muted-foreground">
            <p className="flex items-center justify-center gap-2">
              Need help? 
              <a 
                href="mailto:arpit@reviewplum.com" 
                className="text-primary hover:underline inline-flex items-center gap-1"
              >
                <Mail className="w-3 h-3" />
                Contact us
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;